import React from 'react'
import { Link } from 'react-router-dom'
import Ellipse from '../../resources/images/Ellipse.png'
import Logo from '../../resources/images/logo-full.svg'

const ProductionToolsHeader = ({ badge = 'Production Tools' }) => (
  <header className="pt-hdr">
    <div
      className="pt-hdr-bg"
      style={{ backgroundImage: `url(${Ellipse})` }}
      aria-hidden
    />
    <Link to="/" className="pt-logo-link">
      <img src={Logo} alt="PitchBlu" className="pt-logo-img" />
    </Link>
    {badge ? <div className="pt-hdr-badge">{badge}</div> : null}
  </header>
)

export default ProductionToolsHeader
